<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="edit-rate-code content-wrapper">
      <div class="page-header">{{ $t('editRateCode') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'HotelRateCodeList' }">{{ $t('rateCodeList') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editRateCode') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('code')" :required="true">
          <el-input class="text-uppercase" v-model="rateCode.code" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('name')" :required="true">
          <el-input v-model="rateCode.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('includeBreakfast')">
          <el-radio-group v-model="rateCode.includeBreakfast" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('yes') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('no') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="rateCode.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <RateCodePeriodList
        v-model="rateCodeDetailList"
        :roomTypeList="roomTypeList">
      </RateCodePeriodList>
      <el-form ref="form" label-width="150px" style="width: 500px; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onUpdateRateCodeButtonClick">{{ $t('applyEdit') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Hotel/ManageHotel/RateCode/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import HotelRateCodeApi from '@/api/hotel/rate-code-api'
import RateCodePeriodList from '@/views/Hotel/ManageHotel/RateCode/components/RateCodePeriodList'
import ContentContainer from '@/components/ContentContainerComponent'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'

export default {
  name: 'HotelRateCodeEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, RateCodePeriodList },
  i18n: { messages: i18nMessages },
  props: {
    rateCode: {
      type: Object,
      default: function () {
        return {
          id: '',
          code: '',
          name: '',
          isEnable: STATUS.ENABLE,
          includeBreakfast: 0
        }
      }
    },
    roomTypeList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      STATUS,
      isLoading: false,
      rateCodeDetailList: []
    }
  },
  created: async function () {
    if (this.activeHotelId === undefined || this.activeHotelId === '') {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    if (this.rateCode.id === undefined || this.rateCode.id === '') {
      return this.$router.push({
        name: 'HotelRateCodeList'
      })
    }

    try {
      this.isLoading = true

      this.rateCodeDetailList = await HotelRateCodeApi.detail(this.activeHotelId, this.rateCode.id)
    } catch (err) {
      this.alertError(err.message)
    }

    this.isLoading = false
  },
  computed: {
    ...mapState({
      activeHotelId: state => state.general.activeHotelId
    })
  },
  methods: {
    onUpdateRateCodeButtonClick: async function () {
      try {
        this.startLoading()

        const rateDetailData = {
          rateDetailList: this.rateCodeDetailList
        }

        this.rateCode.code = this.rateCode.code.toUpperCase()
        const data = Object.assign({}, this.rateCode, rateDetailData)
        await HotelRateCodeApi.update(this.activeHotelId, this.rateCode.id, data)
        this.$router.push({
          name: 'HotelRateCodeList'
        })

        const title = this.$t('editRateCodeSuccessTitle')
        const message = this.$t('editRateCodeSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelRateCodeList'
      })
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }

  .rate-period-container {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding-left: 50px;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 100%
  }

  .room-type-group {
    float: left;
    width: 90px;
    text-align: right;
    padding-left: 15px;
  }
</style>
